<div class="report-dashboard-group-host">
  <app-home-dashboard-skeleton *ngIf="loading && useHomeSkeleton" variant="kpis"></app-home-dashboard-skeleton>
  <div class="report-dashboard-group-host-loading" *ngIf="loading && !useHomeSkeleton">
    <i class="fa fa-spinner fa-spin"></i> Loading...
  </div>

  <div class="alert alert-danger m-2" *ngIf="errorMessage">{{ errorMessage }}</div>

  <app-report-dashboard *ngIf="definition && !loading"
    [definition]="definition"
    [expressionContext]="expressionContext"
    [scopeFilters]="scopeFilters"
    [tileDrillDownRoute]="tileDrillDownRoute"
    [showHeader]="false"
    [showDashboardTitle]="false"
    [showFilterBar]="false">
  </app-report-dashboard>
</div>
